<template lang="pug">
#about-account
  .about-heading
    h3.is-size-3
      span Join us at
      span.organization {{ account.organization_short }}
      span this week
  .content
    .address-block.about-block
      h3.is-size-5 Contact Information
      p.address.block-list-item
        b-icon.has-text-grey-lighter(icon="map-marker" size="is-small" pack="fas")
        span(v-html="account._embedded.location.address.string")
      p
        span.block-list-item
          b-icon.has-text-grey-lighter.email-icon(icon="envelope" size="is-small" pack="fas")
          a(
            v-if="account.email"
            :href="`mailto:${account.email}`"
          ) {{ account.email }}

      p
        span.block-list-item(v-if="account.phone_number")
          b-icon.has-text-grey-lighter(icon="phone-alt" size="is-small" pack="fas")
          span {{ account.phone_number }}
    //- .social-block.about-block
    //-   social-links(:value="account.social")
    .services-block.about-block(v-if="account._embedded.services && account._embedded.services.length > 0")
      h3.is-size-5 Service Times
      service-list-item(
        v-for="service in filteredServices"
        :key="service.id"
        :value="service"
      )
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import GoogleMap from '@/components/GoogleMap.vue';
import ServiceListItem from '@/components/ministries/ServiceListItem.vue';
import SocialLinks from '@/components/SocialLinks.vue';
import * as getterTypes from '@/store/types/getters';

export default {
  name: 'about-account',
  components: {
    GoogleMap,
    ServiceListItem,
    SocialLinks,
  },
  computed: {
    ...mapGetters({
      account: getterTypes.GET_ACCOUNT,
    }),
    filteredServices() {
      return _.filter(this.account._embedded.services, { is_ministry_only: false });
    },
  },
};
</script>

<style lang="scss" scoped>
#about-account {
  @include sidebar;
  .about-heading {
    background-size: cover;
    height: 230px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: $white;
    text-align: center;
    h3 {
      span {
        display: block;
      }
    }
  }
  .about-block {
    h3 {
      margin-bottom: 1.25rem !important;
    }
    .block-list-item {
      display: flex;
      align-items: center;
      .icon {
        margin-right: 0.75rem;
      }
      .email-icon {
        position: relative;
        top: 2px;
      }
    }
  }
}
</style>

<style theme="ffc" lang="scss">
#about-account {
  .content {
    border: 1px solid #eaeaea;
    padding: 1.5rem;
  }
}
</style>

<style theme="cwo" lang="scss">
#about-account {
  .about-heading {
    background-image: url('/images/cwo/sanctuary01.jpg');
    border-radius: 4px 4px 0 0;
    h3 {
      .organization {
        font-family: $heading-font;
        font-size: 2.4rem;
      }
    }
  }
  .about-heading, .content {
    h3 {
      font-family: $body-font;
      font-weight: 700 !important;
      margin-bottom: 0;
      line-height: 150%;
    }
  }
}
</style>
